"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAutoCorrectedCurrencyPipe;

/**
 * pipe function for text-mask (https://github.com/text-mask/text-mask)
 * Allows modification of the 'conformed value' before it is displayed on the screen.
 *
 * This pipe function is for displaying '$' instead of '$0' if input value equals 0.
 * However, it will not modify the conformed value if it already has a '$' prefixed.
 * This means user can still type in $0, $0.0, $0.00, etc.
 */
function createAutoCorrectedCurrencyPipe() {
  return function (conformedValue, config) {
    // If value is exactly zero without $ symbol, display $
    if (parseFloat(config.rawValue) === 0) {
      return '$';
    } // Otherwise return the original confirmedValue


    return conformedValue;
  };
}
//# sourceMappingURL=createAutoCorrectedCurrencyPipe.js.map